import React, { FunctionComponent } from 'react';
import { SbBlokData } from '@storyblok/react';

import { Carousel, P } from '@savebetter/components';

import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface Logo extends SbBlokData {
  logo: MediaProps[];
  link: { cached_url: string };
  target: '_self' | '_blank';
}
interface Blok extends PageSectionBlok {
  title?: string;
  subtitle?: string;
  logos: Logo[];
}
interface LogoComponentProps extends PageSectionProps {
  blok: Blok;
}

export const LogoCarousel: FunctionComponent<React.PropsWithChildren<LogoComponentProps>> = ({ blok }) => {
  const { logos, hasBackground, hasBorder, hasPaddingTop, hasPaddingBottom, title, subtitle } = blok;
  const slides = logos.map((logoItem, index) => {
    const { logo, link, target } = logoItem;
    return (
      <div key={index} className="flex items-center">
        {link.cached_url ? (
          <a href={link.cached_url} target={target}>
            <img alt={logo[0]?.alt} src={logo[0]?.img} />
          </a>
        ) : (
          <img alt={logo[0]?.alt} src={logo[0]?.img} />
        )}
      </div>
    );
  });
  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      {title && <PageSectionHeader>{title}</PageSectionHeader>}
      {subtitle && <P className="lg:sb-page-description mx-auto text-center">{subtitle}</P>}
      <Carousel
        contentLabel={''}
        slides={slides}
        settings={{ lg: { slidesPerPage: Math.min(5, slides.length) } }}
        useDefaultSlideWrapper={false}
      />
    </Section>
  );
};
